import { render } from "./LollaLandHome.vue?vue&type=template&id=5d0302c2&scoped=true"
import script from "./LollaLandHome.vue?vue&type=script&lang=js"
export * from "./LollaLandHome.vue?vue&type=script&lang=js"

import "./LollaLandHome.vue?vue&type=style&index=0&id=5d0302c2&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0302c2"]])

export default __exports__